module.exports = __webpack_public_path__ + "img/check-top.1e92fe96.svg";